<div class="modal opened">
      <div class="modal-message-one">
        <div class="modal-message-main">
          <span class="modal-close" (click)="onButtonCloseClick($event)" title="Close">&#10005;</span>
          <h2>{{title}}</h2>
          <div class="txt" [innerHTML]="text"></div>
          <div class="element text-area">
            <core-helpers-forms-wysiwyg-extended
              [placeholder]="messagePlaceholder"
              [emojis]="emojis"
              (textChange)="onMessageChange($event)"
            ></core-helpers-forms-wysiwyg-extended>
          </div>
          <div *ngIf="limitReached" class="message-limit">
            <span>The message content is too long.</span>
          </div>
          <fieldset *ngIf="buttonEnabled">
            <core-helpers-forms-button
                [disabled]="disabled"
                [type]="buttonType"
                [text]="buttonText"
                (submit)="onButtonClick($event)"
            ></core-helpers-forms-button>
          </fieldset>
      </div>
    </div>
</div>
